import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// routes
import {
  PATH_DASHBOARD,
  PATH_ADMIN_DASHBOARD,
  PATH_TRAINER_DASHBOARD,
  USER_ROLE,
  PATH_AUTH,
} from '../routes/paths';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';
import { setEmail } from '../redux/slices/emailverification';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();

  const dispatch = useDispatch();

  if (isAuthenticated) {
    // PATH_AUTH.email_verify
    if (user?.email_verified === false) {
      dispatch(setEmail(user?.email));
      return <Navigate to={PATH_AUTH.email_verify_code} />;
    }
    if (
      user?.role !== undefined &&
      user?.role !== null &&
      (user?.role === USER_ROLE.admin ||
        user?.role === USER_ROLE.salesAgent ||
        user?.role === USER_ROLE.financeAdmin)
    ) {
      return <Navigate to={PATH_ADMIN_DASHBOARD.general.app} />;
    }
    if (user?.role !== undefined && user?.role !== null && user?.role === USER_ROLE.owner) {
      return <Navigate to={PATH_DASHBOARD.root} />;
    }
    if (
      user?.role !== undefined &&
      user?.role !== null &&
      (user?.role === USER_ROLE.trainer ||
        user?.role === USER_ROLE.assistantTrainer ||
        user?.role === USER_ROLE.jockey)
    ) {
      return <Navigate to={PATH_TRAINER_DASHBOARD.app} />;
    }
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <> {children} </>;
}
